export function getHeader() {
	const userDataStr = localStorage.getItem("user");
	const userData = JSON.parse(userDataStr);
	const token = userData.token;
	return {
		Authorization: "Bearer " + token,
	};
}
